/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { MessageService } from '@src/app/shared/message.service';
import { uuid } from '@src/app/model/abstract-object';
import { map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { TenantService } from '@src/app/shared/tenant.service';

export interface RequestIcon { id: uuid, name: string }
@Injectable({
    providedIn: 'root'
})
export class RequestIconsService {
    protected http = inject(HttpClient);
    protected messageService = inject(MessageService);


    httpOptions = {
        headers: new HttpHeaders().set('Content-Type', 'text/plain,application/xml')
    };

    protected cache: RequestIcon[];
    protected typeString = 'Document';

    readonly iconUrl = TenantService.ajaxPath + 'requestIcons';

    getIcons(): Observable<RequestIcon[]> {
        if (!this.cache) {
            return this.http.get(this.iconUrl).pipe(map(icons => {
                console.log(icons);
                this.cache = icons as RequestIcon[];
                return this.cache;
            }));
        } else {
            return of(this.cache);
        }
    }
}